export default __webpack_public_path__ + "c09f26ac0c2e47d7d46a980ac36095fe.png";